import { Modal } from "flowbite-react";
import { useState } from "react";
import Sidebar from "./components/Sidebar";
import PersonalDetailsForm from "./components/PersonalDetailsForm";
import CompanyDetailsForm from "./components/CompanyDetailsForm";

const SettingsModal = ({ handleCloseSettings }) => {
  const [selectedPage, setSelectedPage] = useState("personal");

  const renderContent = () => {
    switch (selectedPage) {
      case "personal":
        return <PersonalDetailsForm />;
      case "company":
        return <CompanyDetailsForm />;
      default:
        return <div>Select a page</div>;
    }
  };

  return (
    <Modal dismissible show={true} onClose={handleCloseSettings} size="5xl">
      <Modal.Header>Settings</Modal.Header>
      <Modal.Body className="p-0 rounded-b-md">
        <div className="flex gap-2 h-[70vh]">
          <Sidebar
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
          />
          <div className="h-full w-full overflow-y-auto rounded-l-lg bg-gray-100">
            {renderContent()}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SettingsModal;
